<template>
  <div class="flex items-center justify-between">
    <div class="flex">
      <div class="flex items-center">
        <div
          class="text-2xl font-bold text-sky_secondary"
        >
          <template v-if="$store.getters['auth/paysTaxes']">
            {{ $helpers.formatCurrency(totalTaxedPrice) }}
          </template>
          <template v-else>
            {{ $helpers.formatCurrency(totalPrice) }}
            <small v-if="!$store.getters['auth/paysTaxes']">HT</small>
          </template>
        </div>
        <div v-if="crossedPrice !== totalTaxedPrice" class="ml-2 text-sky_cart_grey text-xs line-through">
          <template v-if="$store.getters['auth/paysTaxes']">
            {{ $helpers.formatCurrency(crossedPrice) }}
          </template>
          <template v-else>
            {{ $helpers.formatCurrency(crossedPreTaxPrice) }}
            <small v-if="!$store.getters['auth/paysTaxes']">HT</small>
          </template>
        </div>
      </div>
    </div>
    <div class="text-xs text-sky_cart_grey">
      Prix unitaire:
      <span v-if="unitTaxedPrice !== product.pricing.crossed_taxed_price" class="mx-2 line-through">
        <template v-if="$store.getters['auth/paysTaxes']">
          {{ $helpers.formatCurrency(product.pricing.crossed_taxed_price) }}
        </template>
        <template v-else>
          {{ $helpers.formatCurrency(product.pricing.crossed_price) }}
          <small v-if="!$store.getters['auth/paysTaxes']">HT</small>
        </template>
      </span>
      <template v-if="$store.getters['auth/paysTaxes']">
        {{ $helpers.formatCurrency(unitTaxedPrice) }}
      </template>
      <template v-else>
        {{ $helpers.formatCurrency(unitPrice) }}
        <small v-if="!$store.getters['auth/paysTaxes']">HT</small>
      </template>
    </div>
  </div>
</template>

<script>
import orderBy from 'lodash.orderby'
export default {
  props: {
    product: {
      required: true,
      type: Object
    },
    quantity: {
      required: false,
      default: 1,
      type: Number
    }
  },
  computed: {
    totalTaxedPrice () {
      return this.unitTaxedPrice * this.quantity
    },
    totalPrice () {
      return this.unitPrice * this.quantity
    },
    unitTaxedPrice () {
      const decreasingPrice = orderBy(this.product.pricing.decreasing_prices, ['minimal_quantity'], ['desc']).find(p => p.minimal_quantity <= this.quantity)
      if (decreasingPrice) {
        return decreasingPrice.unit_taxed_price
      }
      return this.product.pricing.unit_taxed_price
    },
    unitPrice () {
      const decreasingPrice = orderBy(this.product.pricing.decreasing_prices, ['minimal_quantity'], ['desc']).find(p => p.minimal_quantity <= this.quantity)
      if (decreasingPrice) {
        return decreasingPrice.unit_price
      }
      return this.product.pricing.unit_price
    },
    crossedPrice () {
      return this.product.pricing.crossed_taxed_price * this.quantity
    },
    crossedPreTaxPrice () {
      return this.product.pricing.crossed_price * this.quantity
    }
  }
}
</script>
